<template>
    <b-alert variant="danger" :show="checkIfInternetExplorer">
        <font-awesome-icon :icon="['fas', 'exclamation-triangle']"/>
        Internet Explorer (<font-awesome-icon :icon="['fab', 'internet-explorer']"/>) wird nicht unterstützt! Bitte verwenden Sie einen anderen Browser
        (z.B.
        <a href="https://www.microsoft.com/en-us/edge" target="_blank">Edge</a>,
        <a href="https://www.google.de/chrome/?brand=CHBD&gclid=Cj0KCQiApt_xBRDxARIsAAMUMu--Us_qPdKKnLWy-w0qMiQ3i81feQMAwoJTZi8vJoUGIGci5CPdPk8aAodIEALw_wcB&gclsrc=aw.ds" target="_blank">Chrome</a>
        oder
        <a href="https://www.mozilla.org/de/firefox/new/" target="_blank">Firefox</a>).
        <br>
        <br>

        <b-button href="https://www.microsoft.com/en-us/edge" target="_blank">
            <font-awesome-icon :icon="['fab', 'edge']"/>
            Microsoft Edge herunterladen
        </b-button>
        <b-button href="https://www.google.de/chrome/?brand=CHBD&gclid=Cj0KCQiApt_xBRDxARIsAAMUMu--Us_qPdKKnLWy-w0qMiQ3i81feQMAwoJTZi8vJoUGIGci5CPdPk8aAodIEALw_wcB&gclsrc=aw.ds" target="_blank">
            <font-awesome-icon :icon="['fab', 'chrome']"/>
            Google Chrome herunterladen
        </b-button>
        <b-button href="https://www.mozilla.org/de/firefox/new/" target="_blank">
            <font-awesome-icon :icon="['fab', 'firefox']"/>
            Mozilla Firefox herunterladen
        </b-button>
    </b-alert>
</template>

<script>
    import sharedStore from "../../state-management/store"

    export default {
        name: "InternetExplorerCheck",
        computed: {
            checkIfInternetExplorer () {
                let isIE = /*@cc_on!@*/false || !!document.documentMode;
                return isIE;
            }
        },
        mounted() {
            sharedStore.setIsIE11(this.checkIfInternetExplorer);
        }
    }
</script>

<style scoped>

</style>